var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('no-ssr',[_c('map-box',_vm._b({},'map-box',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }